import { signOut } from "aws-amplify/auth";
import { clearProductActivityStorage } from "data/context/ProductActivityContext";
import { clearStrategyActivityStorage } from "data/context/StrategyActivityContext";
import { resetAllStores } from "data/store/zustand-middeware";
import { useActivityStore } from "data/store/ActivityFeed";

const logout = (): void => {
  useActivityStore.getState().reset();
  clearProductActivityStorage();
  clearStrategyActivityStorage();

  resetAllStores();
  signOut();
};

export { logout };
